<template>
  <el-card>
    <template #header>
      <content-header/>
    </template>
    <el-row type="flex">
      <lz-form
        ref="form"
        :get-data="getData"
        :submit="onSubmit"
        :form.sync="form"
        :errors.sync="errors"
        :edit-mode="editMode"
      >
        <el-form-item label="公告标题" required prop="title">
          <el-input v-model="form.title"/>
        </el-form-item>
        <el-form-item label="公告描述" required prop="description">
          <el-input v-model="form.description"/>
        </el-form-item>
        <el-form-item label="投放区域" required prop="area_id">
          <el-select
            v-model="form.area_id"
            clearable
            placeholder="选择区域"
          >
            <el-option
              v-for="i in areas"
              :key="i.id"
              :label="i.name"
              :value="i.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="公告详情" required prop="body">
         <Editor :value="form.body" @input="handelIncrease"/> 
         <!--<tinymce-editor
            ref="editor"
            v-model="form.body"
            :disabled="disabled"
            @onClick="onClick"
          />-->
        </el-form-item>
        <el-form-item label="投放状态" required prop="status">
          <el-radio v-model="form.status" label="0">无效</el-radio>
          <el-radio v-model="form.status" label="1">有效</el-radio>
        </el-form-item>
        <el-form-item label="过期时间" required prop="expiration_time">
          <el-date-picker
            v-model="form.expiration_time"
            type="datetime"
            placeholder="选择日期时间"
          />
        </el-form-item>
      </lz-form>
    </el-row>
  </el-card>
</template>

<script>
import { editAnnouncement, storeAnnouncement, updateAnnouncement } from '@/api/announcements'
import { getAreas } from '@/api/area'
import LzForm from '@c/LzForm'
import FormHelper from '@c/LzForm/FormHelper'
import Editor from '@c/Editor'
import TinymceEditor from '@c/Tinymce/TinymceEditor'

export default {
  name: 'Form',
  components: {
    LzForm,
    Editor,
    TinymceEditor,
  },
  mixins: [
    FormHelper,
  ],
  data() {
    return {
      form: {
        title: '',
        description: '',
        area_id: '',
        body: '',
        status: '1',
        expiration_time: '',
      },
      msg: '',
      disabled: false,
      errors: {},
      areas: [],
      showDetail: false,
    }
  },
  created() {
    if (this.editMode == false) {
      this.showDetail = true
    }
  },
  methods: {
    async getData() {
      const [
        { data: areas },
      ] = await Promise.all([
        getAreas({ all: 1 }),
      ])

      this.areas = [{ id: 0, name: '全部' }]
      areas.map(i => {
        this.areas.push({ id: i.id, name: i.name })
      })

      // console.log(thisstatus.editMode)
      if (this.editMode) {
        const { data } = await editAnnouncement(this.resourceId)
        data.status = data.status ? '1' : '0'
        this.fillForm(data)
      // console.log(this.form.detail, 2222)
      }
    },
    async onSubmit() {
      if (this.editMode) {
        await updateAnnouncement(this.resourceId, this.form)
      } else {
        await storeAnnouncement(this.form)
      }
    },
    handelIncrease(step) {
      // console.log('step', step)
      if (this.form.body == '') {
        this.showDetail = true
      }
      this.form.body = step
    },
    onClick(e, editor) {
      // console.log('Element clicked')
      // console.log(e)
      // console.log(editor)
    },
  },
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatara {
     /* width: 178px; */
    height: 178px;
    display: block;
  }
</style>
